import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarOff } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export const HolidayBanner = () => {
  const [h, setH] = useState(null);
  useEffect(() => {
    axios.get(`${API}/api/portal/holiday/current`).then(({ data }) => setH(data.holiday)).catch(() => {});
  }, []);
  if (!h) return null;
  return (
    <div className="bg-nx-gold text-nx-navy" data-testid="holiday-banner">
      <div className="nx-wrap py-3 flex items-center justify-center gap-3 text-center">
        <CalendarOff size={16} className="shrink-0" />
        <p className="text-xs sm:text-sm font-semibold">
          Holiday Notice — our office remains closed on {h.date_nice} ({h.reason}). Regular operations resume the next working day.
        </p>
      </div>
    </div>
  );
};
